import Section from "@/Molecules/Section";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPhone} from "@fortawesome/free-solid-svg-icons";
import {faPaperPlane} from "@fortawesome/free-regular-svg-icons";

export default () => {
  return <Section
    center
    lighter
    title={'Contact opnemen'}
    subtitle={'Heb je vragen over een product? Neem contact met ons op. We helpen je graag.'}
  >
    <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="bg-white shadow-md rounded-md my-5 p-5 text-center flex flex-col items-center">
        <div className="icon-circle bg-beige"><FontAwesomeIcon size={'4x'} icon={faPaperPlane}/></div>
        <h3>Mail ons</h3>
        <p>Onze medewerkers staan voor je klaar om jouw vragen te beantwoorden.</p>
        <a data-sa-location="contact_sectie" href="mailto:info@mensenlinq.nl" className="btn btn-primary mt-8 mb-5">Mail naar info@mensenlinq.nl</a>
      </div>

      <div className="bg-white shadow-md rounded-md my-5 p-5 text-center flex flex-col items-center">
        <div className="icon-circle bg-beige"><FontAwesomeIcon size={'4x'} icon={faPhone}/></div>
        <h3>Bel ons</h3>
        <p>Op werkdagen zijn wij bereikbaar tijdens kantooruren.</p>
        <a data-sa-location="contact_sectie" href="tel:0888005708" className="btn btn-primary mt-8 mb-5">Bel 088 - 800 5708</a>
      </div>
    </div>
  </Section>
}
